import { useState } from "react";
import Reveal from "@/components/base/Reveal";
import SectionHead from "@/components/base/SectionHead";
import { faqs } from "@/mocks/dailyContest";

const schema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
};

export default function Faq() {
  const [open, setOpen] = useState<number>(0);

  return (
    <section id="faq" className="border-b border-background-300/70 bg-background-100 py-12 md:py-16">
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />
      <div className="container-x grid gap-10 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <Reveal>
            <SectionHead
              eyebrow="常见问题 · 帮你省心"
              title="关于每日大赛网，你想知道的都在这里"
              desc="从内容来源、打榜攻略更新频率到直拍对比口径与爆料可信度，我们在此一次性说清楚，也欢迎补充提问。"
            />
            <div className="mt-6 flex items-center gap-3 rounded-lg border border-primary-200 bg-primary-50 px-5 py-4">
              <i className="ri-questionnaire-line text-xl text-primary-600" aria-hidden="true" />
              <p className="text-[13px] leading-6 text-foreground-700">
                还有没覆盖到的问题？可直接在下方
                <a href="#contact" className="mx-1 font-bold text-primary-600 hover:text-primary-700">投稿线索表单</a>
                留言，我们核实后会在站内更新。
              </p>
            </div>
          </Reveal>
        </div>

        <div className="lg:col-span-7">
          <div className="space-y-3">
            {faqs.map((f, i) => {
              const isOpen = open === i;
              return (
                <Reveal key={f.q} delay={i * 40}>
                  <div className="overflow-hidden rounded-lg border border-background-300/70 bg-background-50">
                    <button
                      type="button"
                      onClick={() => setOpen(isOpen ? -1 : i)}
                      aria-expanded={isOpen}
                      className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-4 text-left"
                    >
                      <span className="flex items-center gap-3">
                        <span
                          className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-xs font-black ${
                            isOpen ? "bg-primary-600 text-background-50" : "bg-background-100 text-foreground-600"
                          }`}
                        >
                          {String(i + 1).padStart(2, "0")}
                        </span>
                        <span className="text-[15px] font-bold text-foreground-900">{f.q}</span>
                      </span>
                      <i
                        className={`text-lg text-foreground-500 transition-transform duration-300 ${
                          isOpen ? "rotate-180 text-primary-600" : ""
                        } ri-arrow-down-s-line`}
                        aria-hidden="true"
                      />
                    </button>
                    <div
                      className={`grid transition-all duration-300 ease-out ${
                        isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                      }`}
                    >
                      <div className="overflow-hidden">
                        <p className="px-5 pb-5 pl-[3.75rem] text-[13px] leading-6 text-foreground-600">{f.a}</p>
                      </div>
                    </div>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}